import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router';
const Leagues = (props) => {
    const { idLeague, strLeague, strSport}=props.league
    const leaguStyle={
        margin:"1px",
        padding:"5px",
        border:"1px solid navy",
        borderRadius:"10px",
        // width:"20%"
        textAlign:"center",
        height:"180px"
    }
    const history=useHistory()
    const buttonClickHandle=(id)=>{
        const url=`/leagues/${id}`
        history.push(url)
    }

    return (
        <div className="col-12 col-sm-4 p-3 g-5" >
        <div style={leaguStyle} className="bg-white">
                <h3>{strLeague}</h3>
                <p>Sports Type:{strSport}</p>
                <button className="btn btn-success" onClick={() => buttonClickHandle(idLeague)}>Explore<FontAwesomeIcon icon={faLongArrowAltRight} /></button>
            </div>
        </div>
    );
};

export default Leagues;